import { FC } from "react";

const LadstepSettings: FC = () => {
  return <>TODO</>;
};

export default LadstepSettings;
